module.exports = __webpack_public_path__ + "static/media/states.777289df.svg";